<template>
  <fragment>
    <AppBody
      title="Produtores / Consumidor"
      subtitle="Consumidor / Cadastrar - Editar"
    >
      <v-row class="mb-12">
        <v-col cols="7">
          <CardModule class="mb-6 fill-height" title="Dados do consumidor">
            <v-row>
              <v-col cols="12" class="d-flex justify-center mb-8">
                <v-hover v-slot:default="{ hover }">
                  <v-avatar
                    size="200px"
                    :color="enterDrag ? 'grey lighten-2' : 'grey lighten-4'"
                    v-if="
                      !$loja_consumidor.cadastro.dados_cadastrais.foto.imagem
                    "
                    @dragover.prevent
                    @dragover.native="enterDrag = true"
                    @dragleave.native="enterDrag = false"
                    @drop="getImagem($event.dataTransfer.files[0])"
                    @click="$refs.inputFile.click()"
                  >
                    <v-icon
                      size="150px"
                      :color="enterDrag ? 'grey lighten-1' : 'grey lighten-2'"
                    >
                      {{ "mdi-account-circle" }}
                    </v-icon>
                    <input
                      ref="inputFile"
                      type="file"
                      style="display: none"
                      accept="image/png, image/jpeg, image/bmp"
                      @change="getImagem($event.target.files[0])"
                    />
                    <v-expand-transition>
                      <v-overlay
                        v-if="hover"
                        class="overlay-add d-flex transition-fast-in-fast-out v-card--reveal white--text"
                      >
                        <div
                          class="d-flex flex-column justify-center align-center"
                        >
                          <v-btn color="primary" fab small class="mb-2">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                          <span class="font-weight-bold"> Adicionar foto </span>
                        </div>
                      </v-overlay>
                    </v-expand-transition>
                  </v-avatar>
                  <v-avatar size="200px" color="grey lighten-4" v-else>
                    <v-img
                      :src="
                        $loja_consumidor.cadastro.dados_cadastrais.foto.imagem
                      "
                      width="100%"
                      height="100%"
                      cover
                    >
                    </v-img>
                    <v-expand-transition>
                      <v-overlay
                        v-if="hover"
                        color="error red lighten-2"
                        class="overlay-add d-flex transition-fast-in-fast-out v-card--reveal white--text"
                      >
                        <div
                          class="d-flex flex-column justify-center align-center"
                        >
                          <v-btn color="error" fab small @click="clearImage()">
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </div>
                      </v-overlay>
                    </v-expand-transition>
                  </v-avatar>
                </v-hover>
              </v-col>
              <v-col cols="6">
                <div class="consumidor-tipo-pacote">
                  <v-radio-group
                    v-model="$loja_consumidor.cadastro.dados_cadastrais.pessoa"
                    row
                  >
                    <span>Pessoa:</span>
                    <v-radio
                      label="Jurídica"
                      :value="'JURIDICA'"
                      class="ml-4"
                    ></v-radio>
                    <v-radio label="Física" :value="'FISICA'"></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="lojas-consumidor-container02">
                  <div class="consumidor-tipo-pacote">
                    <v-checkbox
                      v-model="
                        $loja_consumidor.cadastro.dados_cadastrais
                          .permite_pacote
                      "
                      label="Permite Pacote"
                    >
                    </v-checkbox>
                  </div>
                </div>
              </v-col>
            </v-row>
            <div>
              <v-row
                v-show="
                  $loja_consumidor.cadastro.dados_cadastrais.pessoa ==
                  'JURIDICA'
                "
              >
                <v-col cols="6">
                  <BaseTextField
                    required
                    label="Razão Social"
                    placeholder="Insira a Razão Social"
                    v-model="
                      $loja_consumidor.cadastro.dados_cadastrais.razao_social
                    "
                    :error-messages="
                      $loja_consumidor.cadastro.dados_cadastrais.error
                        .razao_social
                    "
                    @input="
                      $loja_consumidor.cadastro.dados_cadastrais.error.razao_social =
                        []
                    "
                  >
                  </BaseTextField>
                </v-col>
                <v-col cols="6">
                  <BaseTextField
                    required
                    label="CNPJ"
                    placeholder="Insira o CNPJ"
                    v-mask="'##.###.###/####-##'"
                    v-model="$loja_consumidor.cadastro.dados_cadastrais.cnpj"
                    :error-messages="
                      $loja_consumidor.cadastro.dados_cadastrais.error.cnpj
                    "
                    @input="
                      $loja_consumidor.cadastro.dados_cadastrais.error.cnpj = []
                    "
                  >
                  </BaseTextField>
                </v-col>
              </v-row>
              <v-row
                v-show="
                  $loja_consumidor.cadastro.dados_cadastrais.pessoa == 'FISICA'
                "
              >
                <v-col cols="6">
                  <BaseTextField
                    required
                    label="Nome Completo"
                    placeholder="Insira o nome completo"
                    v-model="$loja_consumidor.cadastro.dados_cadastrais.nome"
                    :error-messages="
                      $loja_consumidor.cadastro.dados_cadastrais.error.nome
                    "
                    @input="
                      $loja_consumidor.cadastro.dados_cadastrais.error.nome = []
                    "
                  >
                  </BaseTextField>
                </v-col>
                <v-col cols="6">
                  <BaseTextField
                    label="Data de Nascimento"
                    required
                    v-model="
                      $loja_consumidor.cadastro.dados_cadastrais.dt_nascimento
                    "
                    type="tel"
                    v-mask="['XX/XX/XXXX']"
                    :placeholder="placeholderData"
                    append-icon="mdi-calendar-blank-outline"
                    :error-messages="
                      $loja_consumidor.cadastro.dados_cadastrais.error
                        .dt_nascimento
                    "
                    @input="
                      $loja_consumidor.cadastro.dados_cadastrais.error.dt_nascimento =
                        []
                    "
                  >
                  </BaseTextField>
                </v-col>
              </v-row>
            </div>
            <v-row
              v-show="
                $loja_consumidor.cadastro.dados_cadastrais.pessoa == 'FISICA'
              "
            >
              <v-col cols="6">
                <BaseTextField
                  label="CPF"
                  :required="countryIsBR"
                  placeholder="Insira o documento"
                  v-mask="['###.###.###-##']"
                  v-model="$loja_consumidor.cadastro.dados_cadastrais.documento"
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.documento
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.documento =
                      []
                  "
                >
                </BaseTextField>
              </v-col>
              <v-col
                cols="6"
                v-show="
                  $loja_consumidor.cadastro.dados_cadastrais.pessoa == 'FISICA'
                "
              >
                <BaseTextField
                  label="Passaporte"
                  placeholder="Insira o passaporte"
                  :required="!countryIsBR"
                  v-mask="'XXXXXXXX'"
                  v-model="
                    $loja_consumidor.cadastro.dados_cadastrais.passaporte
                  "
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.passaporte
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.passaporte =
                      []
                  "
                >
                </BaseTextField>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <BaseTextField
                  label="E-mail"
                  required
                  placeholder="Insira o e-mail"
                  v-model="$loja_consumidor.cadastro.dados_cadastrais.email"
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.email
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.email = []
                  "
                >
                </BaseTextField>
              </v-col>
              <v-col cols="6">
                <BaseTextField
                  label="Celular"
                  required
                  placeholder="Insira o nº do celular"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  v-model="$loja_consumidor.cadastro.dados_cadastrais.celular"
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.celular
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.celular =
                      []
                  "
                >
                </BaseTextField>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <BaseSelect
                  label="Status"
                  :items="$config.status"
                  v-model="$loja_consumidor.cadastro.dados_cadastrais.status"
                  required
                  placeholder="Selecione o status"
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.status
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.status = []
                  "
                >
                </BaseSelect>
              </v-col>
              <v-col cols="6">
                <BaseSelect
                  label="Idioma"
                  :items="idiomas"
                  item-text="key"
                  item-value="value"
                  v-model="$loja_consumidor.cadastro.dados_cadastrais.idioma"
                  placeholder="Selecione o Idioma"
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.idioma
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.idioma = []
                  "
                >
                </BaseSelect>
              </v-col>
            </v-row>
          </CardModule>
        </v-col>
        <v-col cols="5">
          <CardModule title="Endereço" class="fill-height">
            <v-row>
              <v-col cols="6">
                <BaseAutocomplete
                  label="País"
                  required
                  needSelection
                  placeholder="Selecione o País"
                  :items="$config.paises.result"
                  v-model="$loja_consumidor.cadastro.dados_cadastrais.pais"
                  :loading="$config.loading_paises"
                  item-text="dsc"
                  item-value="dsc"
                  :filter="searchPais"
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.pais
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.pais = []
                  "
                >
                  <template v-slot:selection="{ item }">
                    <div v-if="item ? (paises = item) : null">
                      {{ item.dsc }}
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div>{{ item.dsc }}</div>
                  </template>
                </BaseAutocomplete>
              </v-col>
              <v-col cols="6">
                <BaseTextField
                  label="CEP"
                  required
                  placeholder="Insira o CEP"
                  v-mask="['#####-###']"
                  v-model="$loja_consumidor.cadastro.dados_cadastrais.cep"
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.cep
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.cep = []
                  "
                >
                </BaseTextField>
              </v-col>
              <v-col cols="6">
                <BaseAutocomplete
                  label="Estado"
                  required
                  needSelection
                  placeholder="Selecione o Estado"
                  :items="$config.estados.result"
                  v-model="$loja_consumidor.cadastro.dados_cadastrais.estado"
                  :loading="$config.loading_estados"
                  item-text="iso_full"
                  item-value="iso_full"
                  :filter="searchEstado"
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.estado
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.estado = []
                  "
                >
                  <template v-slot:selection="{ item }">
                    <div v-if="item ? (estados = item) : null">
                      {{ item.iso_full }}
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div>{{ item.iso_full }}</div>
                  </template>
                </BaseAutocomplete>
              </v-col>
              <v-col cols="6">
                <BaseAutocomplete
                  label="Cidade"
                  required
                  needSelection
                  placeholder="Selecione a Cidade"
                  :items="$config.cidades.result"
                  v-model="$loja_consumidor.cadastro.dados_cadastrais.cidade"
                  :loading="$config.loading_cidades"
                  item-text="dsc_lang"
                  item-value="iso_full"
                  :filter="searchCidade"
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.cidade
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.cidade = []
                  "
                >
                  <template v-slot:selection="{ item }">
                    <div v-if="item ? (cidades = item) : null">
                      {{ item.dsc_lang }}
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div>{{ item.dsc_lang }}</div>
                  </template>
                </BaseAutocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <BaseTextField
                  label="Bairro"
                  required
                  placeholder="Insira o bairro"
                  v-model="$loja_consumidor.cadastro.dados_cadastrais.bairro"
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.bairro
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.bairro = []
                  "
                >
                </BaseTextField>
              </v-col>
              <v-col cols="6">
                <BaseTextField
                  label="Logradouro"
                  required
                  placeholder="Insira o logradouro"
                  v-model="
                    $loja_consumidor.cadastro.dados_cadastrais.logradouro
                  "
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.logradouro
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.logradouro =
                      []
                  "
                >
                </BaseTextField>
              </v-col>
              <v-col cols="6">
                <BaseTextField
                  label="Número"
                  required
                  type="number"
                  placeholder="Insira o número"
                  v-model="
                    $loja_consumidor.cadastro.dados_cadastrais.end_numero
                  "
                  :error-messages="
                    $loja_consumidor.cadastro.dados_cadastrais.error.end_numero
                  "
                  @input="
                    $loja_consumidor.cadastro.dados_cadastrais.error.end_numero =
                      []
                  "
                >
                </BaseTextField>
              </v-col>
            </v-row>
          </CardModule>
        </v-col>
      </v-row>

      <RegistrationActions
        :fixed="true"
        :loader="$loja_consumidor.cadastro.loading"
        :actions="actions"
      />
    </AppBody>
    <ModalVisualizarImagem :image="imagemModal" :size="'consumidor'" />
  </fragment>
</template>

<script>
import LojaConsumidorMixins from "@/mixins/Loja-Consumidor.mixins.js";
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
export default {
  name: "ConsumersSettings",
  mixins: [LojaConsumidorMixins],
  components: {
    CardModule,
    BaseTextField,
    BaseSelect,
    BaseAutocomplete,
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
    ModalVisualizarImagem: () =>
      import("@/components/global/modal-visualizar-imagem.vue"),
  },
  metaInfo: {
    title: "Consumidor | Adicionar/Editar | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Consumidor | Adicionar/Editar | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      actions: [
        {
          name: "Salvar",
          action: () => this.$loja_consumidor.validarCadastro(),
        },
        {
          name: "Cancelar",
          action: () => this.$router.push({ name: "consumers" }),
        },
      ],
      paises: [],
      estados: [],
      cidades: [],
      enterDrag: false,
      imagemModal: "",
      RulesRazao: [
        v =>
          v.length <= 50 ||
          "A razão social não pode ter mais de 50 caracteres!",
      ],
    };
  },
  computed: {
    countryIsBR: function () {
      if (this.$loja_consumidor.cadastro.dados_cadastrais.pais === "Brasil") {
        return true;
      }

      return false;
    },
  },
  methods: {
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    searchPais(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.dsc.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    searchEstado(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.iso_full.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    searchCidade(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.dsc_lang.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    previewImage(imagem) {
      document.getElementsByClassName(
        "modal-body-visualizar-imagem"
      )[0].style.display = "flex";
      this.imagemModal = imagem;
    },
    clearImage() {
      this.$loja_consumidor.cadastro.dados_cadastrais.foto.imagem = null;
      this.$loja_consumidor.cadastro.dados_cadastrais.foto.have = false;
      delete this.$loja_consumidor.cadastro.dados_cadastrais.foto.object;
    },
    getImagem(file) {
      event.preventDefault();
      const self = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.$loja_consumidor.cadastro.dados_cadastrais.foto.imagem =
          reader.result;
        self.$loja_consumidor.cadastro.dados_cadastrais.foto.have = true;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },
  },
  watch: {
    "$loja_consumidor.cadastro.dados_cadastrais.cep"(e) {
      if (e.length === 9) {
        this.$axios
          .get(`https://viacep.com.br/ws/${e}/json/`)
          .then(res => {
            if (res.erro) {
              throw new Error();
            }
            this.$loja_consumidor.cadastro.dados_cadastrais.pais = "Brasil";
            this.$loja_consumidor.cadastro.dados_cadastrais.estado = res.uf
              ? res.uf
              : this.$loja_consumidor.cadastro.dados_cadastrais.estado;
            this.$loja_consumidor.cadastro.dados_cadastrais.cidade =
              res.localidade
                ? res.localidade
                : this.$loja_consumidor.cadastro.dados_cadastrais.cidade;
            this.$loja_consumidor.cadastro.dados_cadastrais.bairro = res.bairro
              ? res.bairro
              : this.$loja_consumidor.cadastro.dados_cadastrais.bairro;
            this.$loja_consumidor.cadastro.dados_cadastrais.logradouro =
              res.logradouro
                ? res.logradouro
                : this.$loja_consumidor.cadastro.dados_cadastrais.logradouro;
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
    paises(e) {
      this.$config.getEstados(e.id);
    },
    estados(e) {
      this.$config.getCidades(e.id);
    },
  },
  mounted() {
    this.$config.getPaises();
    if (this.$loja_consumidor.consumidorAddOrEdit != "editar") {
      this.$loja_consumidor.cadastro.dados_cadastrais.pessoa = "FISICA";
    }
  },
  destroyed() {
    this.$loja_consumidor.limpaFormularioDeConsumidor();
  },
};
</script>

<style scoped>
.lojas-consumidor-subtitle {
  width: 487px;
  font-size: 1em;
  align-self: flex-start;
  margin-top: 20px;
}

.consumidor-tipo-pacote {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  padding: 10px 15px 10px 15px;
}

.lojas-consumidor-container02 {
  flex: 0 0 auto;
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  border-radius: 20px;
  flex-direction: row;
  justify-content: center;
  margin-top: 23px;
}

.input-file {
  border-radius: 10px;
  width: 100%;
}

.lojas-consumidor-dados-cadastrais-container003 {
  flex: 0 0 auto;
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  padding-right: 0.3125rem;
  flex-direction: row;
  justify-content: flex-start;
}

.lojas-consumidor-dados-cadastrais-container004 {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #c9c9c9;
}

.lojas-consumidor-dados-cadastrais-container005 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.lojas-consumidor-dados-cadastrais-container006 {
  flex: 0 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  flex-direction: column;
  justify-content: center;
}
.overlay-add {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
</style>
